<template>
  <div>
    <div class="panel is-radiusless is-shadowless">
      <div
        class="
          panel-heading
          is-flex is-justify-content-space-between is-align-items-start
        "
      >
        <p>Agendas</p>

        <ValidationObserver ref="form" v-slot="{ invalid }">
          <form @submit.prevent="onSubmit" class="is-flex">
            <!-- newOffice name -->
            <ValidationProvider
              name="new_office_name"
              rules="required"
              v-slot="{ errors }"
            >
              <b-field
                :type="errors[0] ? 'is-danger' : ''"
                label="Nome da Agenda"
                label-position="on-border"
              >
                <b-input v-model="newOffice.name" maxlength="30"></b-input>
              </b-field>
            </ValidationProvider>

            <!-- newOffice type -->
            <ValidationProvider
              name="new_office_type"
              rules="required"
              v-slot="{ errors }"
            >
              <b-field
                :message="errors[0]"
                :type="errors[0] ? 'is-danger' : ''"
                label="Tipo de Agenda"
                label-position="on-border"
              >
                <b-select v-model="newOffice.type" class="is-fullwidth">
                  <option
                    v-for="(type, index) in officeTypes"
                    :value="type.value"
                    :key="index"
                  >
                    {{ type.name }}
                  </option>
                </b-select>
              </b-field>
            </ValidationProvider>

            <b-button
              :disabled="invalid"
              native-type="submit"
              class="button is-info is-pulled-right"
            >
              Criar Agenda
            </b-button>
          </form>
        </ValidationObserver>
      </div>
    </div>

    <!-- offices -->
    <b-table
      :data="offices"
      detailed
      detail-key="_id"
      :opened-detailed="OpenedDetails"
      @details-open="(row) => getOfficeSettings(row._id)"
      :show-detail-icon="false"
      class="is-fullwidth"
    >
      <b-table-column label="Agenda" v-slot="props"
        >{{ props.row.name }} - {{ _officeTypeName(props.row.type) }}
      </b-table-column>

      <b-table-column label="" v-slot="props">
        <b-field grouped group-multiline>
          <div class="control">
            <b-taglist attached>
              <b-tag>
                <b-icon
                  :icon="props.row.address._id ? 'check' : 'close'"
                  :type="props.row.address._id ? 'is-success' : 'is-danger'"
                ></b-icon>
              </b-tag>
              <b-tag>Endereço</b-tag>
            </b-taglist>
          </div>
          <div class="control">
            <b-taglist attached>
              <b-tag>
                <b-icon
                  :icon="props.row.covenants.length > 0 ? 'check' : 'close'"
                  :type="
                    props.row.covenants.length > 0 ? 'is-success' : 'is-danger'
                  "
                ></b-icon>
              </b-tag>
              <b-tag>Convênios</b-tag>
            </b-taglist>
          </div>
          <div class="control">
            <b-taglist attached>
              <b-tag>
                <b-icon
                  :icon="props.row.procedures.length > 0 ? 'check' : 'close'"
                  :type="
                    props.row.procedures.length > 0 ? 'is-success' : 'is-danger'
                  "
                ></b-icon>
              </b-tag>
              <b-tag>Procedimentos</b-tag>
            </b-taglist>
          </div>
          <div class="control">
            <b-taglist attached>
              <b-tag>
                <b-icon
                  :icon="props.row.schedules.length > 0 ? 'check' : 'close'"
                  :type="
                    props.row.schedules.length > 0 ? 'is-success' : 'is-danger'
                  "
                ></b-icon>
              </b-tag>
              <b-tag>Horários</b-tag>
            </b-taglist>
          </div>
        </b-field>
      </b-table-column>
      <b-table-column custom-key="actions" v-slot="props">
        <div class="buttons">
          <b-button
            @click="props.toggleDetails(props.row)"
            class="button is-info"
          >
            Configurar Agenda
          </b-button>
          <b-button @click="delOffice(props.row._id)" class="button is-danger">
            Excluir Agenda
          </b-button>
        </div>
      </b-table-column>

      <template #detail="props">
        <b-tabs v-model="activeTab" type="is-boxed">
          <b-tab-item label="Endereço do Consultório" icon="home-map-marker">
            <Address
              :officeId="props.row._id"
              :address="props.row.address"
              @setAddress="(v) => (props.row.address = v)"
            />
          </b-tab-item>

          <b-tab-item label="Convênios">
            <Covenant
              :officeId="props.row._id"
              :covenants="props.row.covenants"
              @updateCovenants="(v) => (props.row.covenants = v)"
            ></Covenant>
          </b-tab-item>

          <b-tab-item label="Procedimentos">
            <Procedure
              :officeId="props.row._id"
              :procedures="props.row.procedures"
              @updateProcedures="(v) => (props.row.procedures = v)"
            ></Procedure>
          </b-tab-item>

          <b-tab-item label="Horários">
            <Schedule
              :officeId="props.row._id"
              :schedules="props.row.schedules"
              @updateSchedules="(v) => (props.row.schedules = v)"
            ></Schedule>
          </b-tab-item>

          <b-tab-item label="Atendentes">
            <Attendant
              :officeId="props.row._id"
              :attendants="props.row.users"
              @updateAttendants="(v) => (props.row.users = v)"
            ></Attendant>
          </b-tab-item>

          <b-tab-item label="Outras Configurações">
            <OtherSettings
              :officeId="props.row._id"
              :requiredFields="props.row.requiredFields"
              :msgOnSchedule="props.row.msgOnSchedule"
            ></OtherSettings>
          </b-tab-item>
        </b-tabs>
      </template>
    </b-table>
  </div>
</template>
<script>
import { mask } from "vue-the-mask";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import officeTypes from "./../../data/officeTypes";
import Address from "./Address.vue";
import Covenant from "./Covenant.vue";
import Procedure from "./Procedure.vue";
import Schedule from "./Schedule.vue";
import Attendant from "./Attendant.vue";
import OtherSettings from "./OtherSettings.vue";
extend("required", {
  ...required,
  message: "Esse campo é requerido",
});
export default {
  name: "Doctors",
  directives: { mask },
  components: {
    ValidationProvider,
    ValidationObserver,
    Address,
    Covenant,
    Procedure,
    Schedule,
    Attendant,
    OtherSettings,
  },
  data() {
    return {
      newOffice: {},
      offices: [],
      office: {},
      OpenedDetails: [],
      officeTypes,
      activeTab: "",
    };
  },
  computed: {
    user: function () {
      return this.$store.getters.user;
    },
  },
  methods: {
    //seta "OpenedDetails"
    getOfficeSettings(officeId) {
      this.office = this.offices.find((f) => f._id.toString() == officeId);
      this.OpenedDetails = [officeId];
      this.activeTab = 0;
    },
    delOffice(officeId) {
      const self = this;
      self.$buefy.dialog.confirm({
        title: "Excluir Agenda",
        message: "Essa operação não poderá ser desfeita",
        confirmText: "Sim Excluir",
        type: "is-danger",
        hasIcon: false,
        onConfirm: function () {
          self.$http.delete(`office/${officeId}`).then(() => {
            self.offices = self.offices.filter((f) => f._id != officeId);
          });
        },
      });
    },
    _officeTypeName(v) {
      if (!v) return;
      return this.officeTypes.find((f) => f.value == v).name;
    },
    onSubmit() {
      this.$refs.form.validate().then((success) => {
        if (!success) {
          return;
        }

        this.$http.post(`office`, this.newOffice).then((response) => {
          this.offices.push(response.data);
          this.$refs.form.reset();
          this.newOffice = {};
        });

        //this.$refs.form.reset();
      });
    },
  },
  created() {
    this.$http.get(`office`).then((response) => (this.offices = response.data));
  },
};
</script>
